import React from "react";
import styled from "styled-components";
import { colors } from "utils";
import { BORDER, WHITE } from "./styles";

const Field = styled.div`
  align-items: center;
  column-gap: 6px;
  display: inline-grid;
  grid-template-columns: auto auto;
  row-gap: 2px;
`;

const FieldLabel = styled.label`
  color: ${colors.milkGlass950};
  font-size: 12px;
  font-weight: 600;
  margin: 0;
  text-transform: uppercase;
`;

const Select = styled.select`
  background: ${WHITE};
  border: 1px solid ${BORDER};
  border-radius: 8px;
  color: ${colors.nightlyWoods950};
  font-size: 13px;
  font-weight: 400;
  padding: 6px 8px;

  &:disabled {
    background: ${colors.milkGlass200};
    color: ${colors.milkGlass950};
  }
`;

const Note = styled.p`
  color: ${colors.milkGlass950};
  font-size: 12px;
  grid-column: 1 / -1;
  margin: 0;
`;

export const ChoiceDropdown = ({ id, label, options, value, onChoose, disabled, note }) => (
  <Field>
    <FieldLabel htmlFor={id}>{label}</FieldLabel>
    <Select id={id} value={value} disabled={disabled} onChange={(event) => onChoose(event.target.value)}>
      {options.map((option) => (
        <option key={option.value} value={option.value}>
          {option.label}
        </option>
      ))}
    </Select>
    {note && <Note>{note}</Note>}
  </Field>
);
